<template>
  <div>
    <b-container>
        <b-row>
            <b-col sm="12" cols="12" >
                <b-card no-body border-variant="msstream" class="marginal">
                    <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
                    <h5>{{video.title}} - UUID:{{video.uuid}}</h5>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-form-textarea
                            id="textarea"
                            v-model="videoJson"
                            placeholder=""
                            rows="0"
                            max-rows="25"
                            ></b-form-textarea>
                        </b-row>
                        <b-row class="justify-content-around" style="margin-top:15px;">
                            <b-button variant="green" @click="updateVideo()" ><i class="fas fa-check"></i> Update</b-button>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <b-modal ref="confirmDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('delete')}}</h3>
      </div>
      <p>{{$ml.get('confirmDeleteUser')}}</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="removeUser(userSelected);hideModal('confirmDelete')">{{$ml.get('yesDelete')}}</b-btn>

          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="hideModal('confirmDelete')">{{$ml.get('cancel')}}</b-btn>

      </b-row>
  </b-modal>

  <b-modal ref="UpdateOk" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('successTitle')}}</h3>
      </div>
      <p>{{$ml.get('updateSuccess')}}</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="green" block @click="hideModal('UpdateOk')">Ok</b-btn>

      </b-row>
  </b-modal>
  <b-modal ref="UpdateError" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('Error')}}</h3>
      </div>
      <p>{{$ml.get('updateErrorVideo')}}</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('UpdateError')">Ok</b-btn>

      </b-row>
  </b-modal>
  <b-modal ref="UpdateParseError" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('Error')}}</h3>
      </div>
      <p>{{$ml.get('jsonParseError')}}</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('UpdateParseError')">Ok</b-btn>

      </b-row>
  </b-modal>
  </div>
</template>

<script>
import VideoService from '@/services/video.service';

import { EventBus } from '@/event-bus.js';

var videoService = new VideoService();

export default {
  name: 'VideoAdmin',
  data: function() {
      return {
          uuid: '',
          video: {},
          videoJson : ''
      }
  },
  mounted() {
      this.uuid = this.$route.params['uuid'];
      this.getVideo();
  },
  methods:{

    getVideo() {
        videoService.getVideoById(this.uuid, this.$auth.token()).then(video => {
            let js = JSON.stringify(video, null, 2);
            this.videoJson = js;
            this.video = video;
        }).catch(err => {

        })
    },
    updateVideo() {
        let finalVideo = {};
        try {
            finalVideo = JSON.parse(this.videoJson);
        } catch(err) {
            this.showModal('UpdateParseError')
            return;
        }
         
        videoService.putVideoAdmin(finalVideo, this.uuid, this.$auth.token()).then(video => {
            let js = JSON.stringify(video, null, 2);
            this.videoJson = js;
            this.video = video;
            this.showModal('UpdateOk')
        }).catch(err => {
            this.showModal('UpdateError')
        })
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
  }
}
</script>
<style scoped lang="scss">



</style>